import styled, { css } from "styled-components/macro";

import { space } from "shared/styles/constants";
import { hoverFocus } from "shared/styles/defaults";

export const StyledPhoneField = styled.div`
  flex: 1;
  display: flex;

  > * {
    flex: 0 0 auto;
  }

  input {
    flex: 1 1 auto;

    margin-left: ${space.xs};
    padding: 0;
    outline: none; // reset focus style

    color: inherit;
    font-family: inherit;
  }
`;

interface StyledPhoneSelectProps {
  isOpen?: boolean;
}

export const StyledPhoneSelect = styled.button<StyledPhoneSelectProps>`
  display: flex;

  padding: 0;
  outline: none; // reset focus style

  font-family: inherit;

  ${({ isOpen }) =>
    isOpen &&
    css`
      ${hoverFocus.focusStyle}
    `}

  ${hoverFocus.defaultFocus}
`;

export const StyledPhoneNumber = styled.span`
  flex: 1;

  input {
    display: block;
    width: 100%;
  }
`;
